import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/downloads/DownloadAbout'

const Download: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'UI/UX 生成AI クラウドネイティブ DevOps モダンアプリケーション開発'}
        image={'https://www.i3design.jp/ogp_logo.png'}
        url={'https://www.i3design.jp/download/about/'}
        title="UI/UX＆モダナイズ開発サービス紹介ガイド | 資料ダウンロード | i3DESIGN アイスリーデザイン"
        description="i3DESIGN（アイスリーデザイン）の会社概要および提供するサービス一覧を紹介しております"
      />
      <Template />
    </>
  )
}

export default Download
